import {ChevronRightIcon} from '@primer/octicons-react'
import {IconButton, ProgressBar} from '@primer/react'
import {DockedPanel, useDockedPanelActions} from '../../../../../contexts/DockedPanelContext'
import styles from './MiniMergeSections.module.css'

export function CommentsMiniStatus() {
  const {openPanel} = useDockedPanelActions()

  return (
    <section className={styles.MiniStatus} aria-label="Comments">
      <div className={styles.MiniStatusLabelRow}>
        {/* TODO: Add a leading icon based on the comments state. */}
        <strong>Comments</strong>
        <IconButton
          aria-label="View comments"
          icon={ChevronRightIcon}
          onClick={event => openPanel(DockedPanel.Comments, {returnFocusTo: event.currentTarget})}
          size="small"
          variant="invisible"
        />
      </div>
      {/* TODO: Derive progress from resolved comments. */}
      <ProgressBar aria-label="Comments progress" className={styles.MiniStatusProgress} progress={100} />
    </section>
  )
}
